import { jsx as h } from "react/jsx-runtime";
import { SvgIcon as o } from "../SvgIcon.js";
const V = (r) => /* @__PURE__ */ h(o, { ...r, children: /* @__PURE__ */ h("path", { d: "M9.97269 8.33787c.91661 0 1.66761.75096 1.66761 1.66763 0 .9166-.751 1.6675-1.66761 1.6675-.91662 0-1.66758-.7509-1.66758-1.6675 0-.91667.75096-1.66763 1.66758-1.66763ZM3.33548 3.33511v5.00276h1.66758V5.0027h3.33517V3.33511H3.33548ZM16.6651 8.33787h-1.6676V5.0027h-3.3351V3.33511h5.0027v5.00276Zm0 3.32413h-1.6676v3.3352h-3.3351v1.6676h5.0027V11.662Zm-8.32687 5.0028v-1.6676H5.00306V11.662H3.33548v5.0028h5.00275Z" }) });
export {
  V as SquareBorder
};
//# sourceMappingURL=SquareBorder.js.map
